/** Volume tiers (expected revenue) and corresponding monthly prices, excl. tax */
export const PRO_ACCOUNT_PRICING_TIERS = [
  { min: 0, max: 999_999 as number | null, price: 70 },
  { min: 1_000_000, max: 4_999_999 as number | null, price: 150 },
  { min: 5_000_000, max: 7_499_999 as number | null, price: 250 },
  { min: 7_500_000, max: 9_999_999 as number | null, price: 350 },
  { min: 10_000_000, max: null, price: 500 },
] as const;

export function formatProAccountPricingAmount(n: number): string {
  return new Intl.NumberFormat("fr-FR").format(n);
}
